import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useHover } from 'javascripts/hooks/use-hover';

import { ChirpButton } from 'javascripts/components/chirp_button';
import { ReactComponent as FollowIcon } from 'images/Follow.svg';
import { ReactComponent as FollowingIcon } from 'images/Following.svg';
import { ReactComponent as UnfollowIcon } from 'images/Unfollow.svg';

import styles from 'stylesheets/components/follow_button';

export function FollowButton({ displayStyle, followingText, followText, isFollowing, onClick, fullWidth }) {
  const [hoverRef, isHovered] = useHover();

  let buttonText;
  let IconClass;
  if (isFollowing && isHovered) {
    buttonText = 'Unfollow';
    IconClass = UnfollowIcon;
  } else if (isFollowing) {
    buttonText = followingText;
    IconClass = FollowingIcon;
  } else {
    buttonText = followText;
    IconClass = FollowIcon;
  }

  if (displayStyle === 'link') {
    return <ChirpButton displayStyle='underline' displayType='link' label={buttonText} onClick={onClick} />;
  }

  return (
    <button
      className={classNames(
        styles.button,
        fullWidth ? styles.fullWidth : null,
        isFollowing ? styles.followingButton : styles.followButton,
      )}
      onClick={onClick}
      ref={hoverRef}
    >
      <IconClass className={styles.icon} />
      {buttonText}
    </button>
  );
}

FollowButton.propTypes = {
  displayStyle: PropTypes.oneOf(['button', 'link']),
  followingText: PropTypes.string,
  followText: PropTypes.string,
  isFollowing: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
};

FollowButton.defaultProps = {
  displayStyle: 'button',
  followingText: 'Following',
  followText: 'Follow',
  fullWidth: false,
};
